// extracted by mini-css-extract-plugin
module.exports = {"overview":"_3vCuzK8xJT8OrIW0hDfW4Y","close":"_171xOqt7m5SFa-uH_9St91","title":"_1pwgdBrOLXD1EXpihX-Pxr","description":"_1Y4msfFM72VVTnCsW1Cr5O"};